import { Redirect, useLocation } from "react-router-dom";

import { useAuthContext } from "@/components/AuthProvider";

// Sends logged out users to a login page with a `next` param pointing back at
// the current location, so they return here once authenticated. Logged in users
// fall through to `children`.
export default function RedirectToLoginWithNext({ loginUrl, children }) {
  const { user } = useAuthContext();
  const location = useLocation();

  if (!user) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Redirect to={`${loginUrl}?next=${next}`} />;
  }

  return children;
}
